import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // If not on home page, navigate to home and then scroll
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo">
          <div className="logo-icon">
            <img src={process.env.PUBLIC_URL + '/images/sibilogo.png'} alt="sibylcues" />
          </div>
          <span>sibylcues</span>
          <span className="tagline">your cue to the future</span>
        </Link>
        <nav>
          <ul>
            <li><button onClick={() => scrollToSection('services')}>Services</button></li>
            <li><button onClick={() => scrollToSection('differentiators')}>How We Stand Out</button></li>
            <li><button onClick={() => scrollToSection('opportunities')}>Opportunities</button></li>
            <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            {location.pathname !== '/internship' && (
              <li><Link to="/internship" className="apply-link">Apply for Internship</Link></li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
